{
    "loginForm": {
        "forgotPassword": "Wachtwoord vergeten?",
        "signIn": "Aanmelden",
        "register": "Register",
        "dontHaveAccount": "Don’t have an account?",
        "guestCheckout": "Guest Checkout",
        "emailAddress": {
            "label": "Gebruikers-ID *",
            "placeholder": "Gebruikers-ID"
        },
        "password": {
            "label": "Wachtwoord *",
            "placeholder": "Wachtwoord"
        },
        "wrongEmailFormat": "This is not a valid email format."
    },
    "miniLogin": {
        "userGreeting": "{{name}}",
        "signInRegister": "Aanmelden"
    }
}
